import { AppState } from '../index';
import * as fromSaveContact from './save-contact.reducer';
import { createSelector } from '@ngrx/store';

export const selectSaveContactState = createSelector(
  (state: AppState) => state.saveContact,
  ({ state }: fromSaveContact.State) => state,
);

export const selectSaveContactError = createSelector(
  (state: AppState) => state.saveContact,
  ({ error }: fromSaveContact.State) => error,
);
